<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="items && items.length" class="px-ogs mb-14">
    <div class="max-w-4xl mx-auto border-b border-grey">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="border-t border-grey"
      >
        <button
          class="flex items-center justify-between w-full text-left leading-snug py-7 pr-2 focus:outline-none group"
          @click="activeItem = activeItem === index ? null : index"
        >
          <h4
            class="group-hover:opacity-100 transition-opacity duration-200 pr-10"
            :class="{
              'font-semibold': activeItem === index,
            }"
          >
            {{ item.heading }}
          </h4>
          <div
            class="flex-shrink-0 w-5 h-5 transition-transform duration-200"
            :style="{
              transform: activeItem === index ? 'rotate(135deg)' : 'rotate(0)',
            }"
          >
            <IconAdd />
          </div>
        </button>
        <div v-if="activeItem === index" class="pb-7 pr-10">
          <div class="rte" v-html="item.body"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IconAdd from "../../../templates/_includes/svg/icon-add.svg";

export default {
  name: "FlexibleContentSimpleAccordionSimple",
  components: { IconAdd },
  props: {
    entry: {
      type: Number,
      default: null,
    },
    block: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      items: null,
      activeItem: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      axios({
        url: "/api",
        method: "post",
        data: {
          query: `
            query accordionQuery($entry: [QueryArgument], $block: [QueryArgument]) {
              entries(id: $entry) {
                ... on pages_simpleFlexibleContent_Entry {
                  flexibleContentSimple(id: $block) {
                    ... on flexibleContentSimple_accordion_BlockType {
                      headingAndBody {
                        ... on headingAndBody_BlockType {
                          heading
                          body
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: {
            entry: this.entry,
            block: this.block,
          },
        },
      }).then((result) => {
        /* eslint-disable no-unused-vars */
        /* eslint-disable prefer-destructuring */
        let data;
        const { entries } = result.data.data;
        if (entries.length) {
          data = entries[0].flexibleContentSimple[0];
        }
        this.items = data.headingAndBody;
      });
    },
  },
};
</script>
